import React, { useState, useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import Heading from "../../../../../common/element/Heading";
import Segment from "../../../../../common/element/Segment";
import Table from "../../../../../common/element/Table";
import SearchImg from "../../../../../assets/icons-svg/search-lg.svg";
import Badge from "../../../../../common/element/Badge";
import ClientInput from "../../../../../common/element/Input/clientInput";
import moment from "moment";
import useCallbackRef from "../../../../../common/element/hooks/useCallbackRef";
import Tooltip from "../../../../../common/element/Tooltip";
import { debounce } from "../../../../../common/snippet/Debouncing";
import {
  GetAllDeshboardTasks,
  UpdateTaskArchiveStatus,
  MarkTaskAsRead,
  GetNotificationTasksForAdminPortal,
  GetAllConserveTeamAndInvites,
  AssignTaskToUser,
} from "../../../../../actions/Admin";
import Select from "../../../../../common/element/Select";
import { useParams, Link } from "react-router-dom";
import useUnauthorizedHandler from "../../../../../common/snippet/useUnauthorizedHandler";
import Tag from "../../../../../common/element/Tag";
import Scrollbar from "../../../../../common/element/ScrollBar";
import BtnLight from "../../../../../common/element/Buttons/btnLight";
import { setBreadcrumbs } from "../../../../../redux/classes/breadcrumbsSlice";
import { decryptId, encryptId } from "../../../../../common/encryptDecrypt/encryptdecrypt";
import { GetWorkerMainDashboardDocsStatusCount } from "../../../../../actions/admin-worker/GetWorkerMainDashboardDocsStatusCount";
import CollapsiblePanel from "../../../../../common/element/CollapsiblePanel";

const Dashboard = () => {
  const { id } = useParams();
  // const orgId = decryptId(id);

  const dispatch = useDispatch();
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const { Tr, Th, Td, THead, TBody } = Table;

  const loginData = JSON.parse(localStorage.getItem("LoginUserData"));
  const user_id = loginData?.userName?.user_id || loginData?.data?.user_id;
  const userRole = loginData?.data?.role?.role_name;
  const [totalTastCount, setTotalTaskCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [workerCountData, SetWorkerCountData] = useState("");

  const scrollContainerRef = useRef(null);
  const [scrollThreshold, setScrollThreshold] = useState(23);
  const [limit, setLimit] = useState(30);
  const [searchTerm, setSearchTerm] = useState("");
  const [notificationList, setNotificationList] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [singleSegmentValue, setSingleSegmentValue] = useState(["Inbox"]);
  const [adminTeamMembers, setAdminTeamMembers] = useState([]);
  const isSuperAdmin = userRole?.toLowerCase() === "super admin";
  const [isCollapsed, setIsCollapsed] = useState(false);

  const getTaskRedirectUrl = (notif) => {
    if (!notif) return "#";

    let providerRoomOrgId = null;
    if (Array.isArray(notif.rooms)) {
      const orgRoom = notif.rooms.find(
        (r) => typeof r === "string" && r.startsWith("org_")
      );
      if (orgRoom) {
        providerRoomOrgId = orgRoom.replace(/^org_/, "").trim();
      }
    }

    const isProviderTask =
      notif.task_assgined?.includes("provider") ||
      notif.rooms?.some(
        (r) => typeof r === "string" && r.trim() === "provider"
      ) ||
      !!providerRoomOrgId;

    const isClientTask =
      notif.task_assgined?.includes("client") ||
      notif.rooms?.some(
        (r) => typeof r === "string" && r.trim() === "client"
      );

    const isWorkerTask =
      notif.is_worker ||
      notif.task_assgined?.includes("worker") ||
      notif.rooms?.some(
        (r) => typeof r === "string" && r.trim() === "worker"
      );

    const rawMsg =
      notif.message ||
      notif.task_message ||
      notif.notification_message ||
      notif.title ||
      notif.task_name ||
      "";
    const msg = rawMsg.toLowerCase();

    let providerTab = "tab1";
    if (
      msg.includes("document") ||
      msg.includes("checklist") ||
      msg.includes("verification") ||
      msg.includes("review") ||
      msg.includes("upload") ||
      msg.includes("client")
    ) {
      providerTab = "tab3";
    } else if (msg.includes("worker")) {
      providerTab = "tab4";
    } else if (msg.includes("payment") || msg.includes("invoice") || msg.includes("fee")) {
      providerTab = "tab5";
    }

    let clientNameParam = "";
    if (providerTab === "tab3" && rawMsg) {
      const forMatch = rawMsg.match(/for\s+([A-Za-z0-9\s\&\-\.\'\"]+)/i);
      if (forMatch && forMatch[1]) {
        const extracted = forMatch[1].trim();
        if (
          extracted &&
          !["verification", "review", "approval", "checklist", "document", "documents"].includes(
            extracted.toLowerCase()
          )
        ) {
          clientNameParam = extracted;
        }
      }
    }

    let clientTab = "tab1";
    if (
      msg.includes("document") ||
      msg.includes("checklist") ||
      msg.includes("verification") ||
      msg.includes("review") ||
      msg.includes("upload")
    ) {
      clientTab = "tab3";
    } else if (msg.includes("provider")) {
      clientTab = "tab2";
    } else if (msg.includes("induction")) {
      clientTab = "tab4";
    } else if (msg.includes("site")) {
      clientTab = "tab5";
    } else if (msg.includes("payment") || msg.includes("invoice") || msg.includes("fee")) {
      clientTab = "tab6";
    }

    if (isProviderTask) {
      const targetOrgId = providerRoomOrgId || notif.organisation_id;
      if (targetOrgId) {
        return `/admin/provider/view-all-provider/specific-provider/${encodeURIComponent(
          encryptId(targetOrgId)
        )}?tab=${providerTab}${clientNameParam ? `&client=${encodeURIComponent(clientNameParam)}` : ""}`;
      }
    }

    if (isClientTask && notif.organisation_id) {
      return `/admin/client/view-all-clients/specific-client/${encodeURIComponent(
        encryptId(notif.organisation_id)
      )}?tab=${clientTab}`;
    }

    if (isWorkerTask) {
      return `/admin/worker/view-all-worker`;
    }

    if (notif.organisation_id) {
      return `/admin/provider/view-all-provider/specific-provider/${encodeURIComponent(
        encryptId(notif.organisation_id)
      )}?tab=${providerTab}${clientNameParam ? `&client=${encodeURIComponent(clientNameParam)}` : ""}`;
    }

    return "#";
  };

  const fetchAdminTeamMembers = useCallback(() => {
    if (isSuperAdmin) {
      dispatch(
        GetAllConserveTeamAndInvites(
          undefined,
          undefined,
          1,
          undefined,
          undefined,
          1000,
          "all"
        )
      ).then((res) => {
        if (res?.success && res.data?.rows) {
          const members = res.data.rows.map((row) => ({
            label: `${row.first_name} ${row.last_name || ""}`.trim(),
            value: row.user_data.user_id,
          }));
          setAdminTeamMembers(members);
        }
      });
    }
  }, [dispatch, isSuperAdmin]);

  useEffect(() => {
    fetchAdminTeamMembers();
  }, [fetchAdminTeamMembers]);

  const handleAssignTask = (notifId, assignedToId) => {
    const payload = {
      notification_id: notifId,
      assigned_to_user_id: assignedToId,
      assigned_by_user_id: user_id,
    };
    dispatch(AssignTaskToUser(payload)).then((res) => {
      if (res?.success) {
        setNotificationList((prevList) =>
          prevList.map((item) => {
            if (item.notification_id === notifId) {
              const assignedMember = adminTeamMembers.find(
                (m) => m.value === assignedToId
              );
              return {
                ...item,
                assigned_to_user_id: assignedToId,
                assigned_to_name: assignedMember?.label,
              };
            }
            return item;
          })
        );
      }
    });
  };

  const renderTaskRow = (notif) => (
    <tr
      key={notif.notification_id}
      className="border-b border-gray-100 hover:bg-blue-50/40 transition-colors"
    >
      <td className="pl-6 pr-4 py-3">
        <Link
          className="flex items-center gap-2.5 group"
          to={getTaskRedirectUrl(notif)}
          onClick={() =>
            !notif?.task_read && onMarkAsRead(notif.notification_id)
          }
        >
          {notif?.task_read === true ? (
            <span className="w-2.5 h-2.5 inline-block flex-shrink-0" />
          ) : (
            <span className="w-2.5 h-2.5 rounded-full bg-blue-500 flex-shrink-0" />
          )}
          <Tooltip title={notif.message}>
            <span
              className={`text-sm text-gray-800 w-[450px] noti-newwrap group-hover:text-blue-600 group-hover:underline ${
                notif?.task_read ? "font-normal" : "font-semibold"
              }`}
            >
              {notif.message}
            </span>
          </Tooltip>
        </Link>
      </td>
      <td className="px-4 py-3 text-sm text-gray-500 whitespace-nowrap">
        {moment(notif.created_date).format("HH:mm DD/MM/YY")}
      </td>
      <td className="px-4 py-3">
        <Tooltip title={notif.trading_name}>
          <Link
            to={getTaskRedirectUrl(notif)}
            onClick={() =>
              !notif?.task_read && onMarkAsRead(notif.notification_id)
            }
            className="text-sm font-medium text-gray-700 hover:text-blue-600 hover:underline noti-newwrap w-56 block"
          >
            {notif?.trading_name ? notif.trading_name : "-"}
          </Link>
        </Tooltip>
      </td>
      <td className="px-4 py-3">
        {singleSegmentValue[0] === "Inbox" ? (
          <span
            className="text-sm text-blue-600 hover:text-blue-800 font-semibold cursor-pointer transition-colors"
            onClick={() => archiveTask(notif, true)}
          >
            Mark Completed
          </span>
        ) : (
          <span
            className="text-sm text-blue-600 hover:text-blue-800 font-semibold cursor-pointer transition-colors"
            onClick={() => archiveTask(notif, false)}
          >
            Mark Incomplete
          </span>
        )}
      </td>
      <td className="px-4 py-3">
        {isSuperAdmin ? (
          <Select
            className="w-52"
            options={adminTeamMembers}
            value={adminTeamMembers.find(
              (m) => m.value === notif.assigned_to_user_id
            )}
            onChange={(val) =>
              handleAssignTask(notif.notification_id, val.value)
            }
            placeholder="Assign"
          />
        ) : (
          <span className="text-sm text-gray-700">
            {notif.assigned_to_name || "-"}
          </span>
        )}
      </td>
    </tr>
  );

  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        {
          label: "Dashboard",
          url: "/admin/provider/dashboard",
          home: "/admin/provider/dashboard",
        },
      ])
    );
  }, []);

  const onSingleSelectionSegmentChange = useCallback(
    (val) => {
      setSingleSegmentValue(val);
    },
    [setSingleSegmentValue]
  );

  const today = moment().startOf("day");
  const yesterday = moment().subtract(1, "day").startOf("day");
  const startOfWeek = moment().startOf("week");
  const startOfMonth = moment().startOf("month");
  const startOfYear = moment().startOf("year");
  const groupedNotifications = notificationList?.reduce(
    (acc, notification) => {
      const createdDate = moment(notification?.created_date);

      if (createdDate.isSame(today, "d")) {
        acc.today.push(notification);
      } else if (createdDate.isSame(yesterday, "d")) {
        acc.yesterday.push(notification);
      } else if (createdDate.isSameOrAfter(startOfWeek)) {
        acc.thisWeek.push(notification);
      } else if (createdDate.isSameOrAfter(startOfMonth)) {
        acc.thisMonth.push(notification);
      } else if (createdDate.isSameOrAfter(startOfYear)) {
        acc.thisYear.push(notification);
      } else {
        acc.earlier.push(notification);
      }
      return acc;
    },
    {
      today: [],
      yesterday: [],
      thisWeek: [],
      thisMonth: [],
      thisYear: [],
      earlier: [],
    }
  );

  useEffect(() => {
    const handleScroll = () => {
      const scrollContainer = scrollContainerRef.current;

      if (
        scrollContainer &&
        scrollContainer.scrollTop >= scrollThreshold &&
        !isFetching &&
        notificationList?.length < totalCount
      ) {
        setLimit((prevLimit) => prevLimit + 10);
        setScrollThreshold((prevThreshold) => prevThreshold + 150);
      }
    };
    const scrollContainer = scrollContainerRef.current;
    scrollContainer?.addEventListener("scroll", handleScroll);

    return () => {
      scrollContainer?.removeEventListener("scroll", handleScroll);
    };
  }, [isFetching, scrollThreshold, totalCount, notificationList]);
  const OnGetNotificationTasksForAdminPortal = useCallback(() => {
    // setIsFetching(true);
    const payload = {
      dashboardType: "worker",
      limit: limit,
      role_name: userRole,
      user_id: user_id,
      is_archived: singleSegmentValue[0] == "Inbox" ? false : true,
      organisation_id: "",
      search: searchTerm,
    };
    dispatch(GetNotificationTasksForAdminPortal(payload)).then((res) => {
      // setIsFetching(false);
      console.log(res)
      if (res?.success === true) {
        const arrayData = res?.data?.rows;
        setNotificationList(arrayData);
        console.log(arrayData)
        setTotalTaskCount(res?.data?.unreadCount);
        setTotalCount(res?.data?.count);
      }
    });
  }, [dispatch, singleSegmentValue, searchTerm, limit]);
  useEffect(() => {
    OnGetNotificationTasksForAdminPortal();
  }, [singleSegmentValue, searchTerm, limit]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.trim());
  };
  const inputchangehandler = useCallbackRef(debounce(handleSearch), []);

  const archiveTask = (notify, is_archived = true) => {
    const payload = {
      role_name: userRole,
      notification_id: notify.notification_id,
      is_archived: is_archived,
      user_id: user_id,
      dashboardType: "worker",
    };
    dispatch(UpdateTaskArchiveStatus(payload)).then((res) => {
      if (res?.success === true) {
        OnGetNotificationTasksForAdminPortal();
      } else if (res?.status === 401) {
        handleUnauthorizedAccess();
      } else {
        // Handle other errors
      }
    });
  };

  const onMarkAsRead = (notifyId) => {
    const payload = {
      role_name: userRole,
      notification_id: notifyId,
      user_id: user_id,
      task_read: true,
      dashboardType: "worker",
    };
    dispatch(MarkTaskAsRead(payload)).then((res) => {
      if (res?.success === true) {
        setTotalTaskCount(totalTastCount - 1); // Fixed typo: 'totalTastCount' -> 'totalTaskCount'
        setNotificationList((prevList) => {
          return prevList.map((item) => {
            if (item?.notification_id === notifyId) {
              return { ...item, task_read: true };
            }
            return item;
          });
        });
      } else if (res?.status === 401) {
        handleUnauthorizedAccess();
      } else {
        // Handle other errors
      }
    });
  };

  useEffect(() => {
    dispatch(GetWorkerMainDashboardDocsStatusCount()).then((response) => {
      if (response.success) {
        SetWorkerCountData(response?.data[0]);
      }
    });
  }, []);
  return (
    <React.Fragment>
      <Heading className="mb-4">Dashboard</Heading>

      <div className="grid grid-container gap-8" style={{ gridTemplateColumns: isCollapsed ? "1fr auto" : undefined }}>
        <div className="flex gap-8 flex-col">
          <div className="bg-white py-5 rounded-xl dark-shadow">
            <div className="card-header flex justify-between border-b border-gray-200 pb-5 px-5 mb-3">
              <span className="text-gray-900 text-base font-semibold flex items-center">
                <span className="mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M6 15L8 17L12.5 12.5M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                Tasks{" "}
                <Tag className="text-blue-800 bg-blue-100 ml-2">
                  {totalTastCount}
                </Tag>
              </span>
              {/* <BtnLight className="w-20 h-9">View All</BtnLight> */}
            </div>
            <div className="flex justify-between mb-3 px-4">
              <Segment
                className="docType-btn"
                value={singleSegmentValue[0] == "Inbox" ? "Inbox" : "Archive"}
                onChange={(val) => onSingleSelectionSegmentChange(val)}
              >
                <Segment.Item value="Inbox">Open</Segment.Item>
                <Segment.Item value="Archive">Completed</Segment.Item>
              </Segment>
              <div className="w-80 h-10">
                <div className="input-wrapper">
                  <div className="input-suffix-start left-3.5">
                    <img src={SearchImg} alt="" className="h-5" />
                  </div>
                  <ClientInput
                    type="text"
                    className="input  pl-10 w-80  input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    placeholder="Search"
                    inputchangehandler={inputchangehandler}
                    name={"search"}
                  />
                </div>
              </div>
            </div>
            <div
              ref={scrollContainerRef}
              className="notification-list-container overflow-y-auto max-h-[839px]"
            >
              <Table className="min-w-full whitespace-nowrap">
                <THead>
                  <Tr>
                    <Th className="pl-6 w-[450px]	">Notification</Th>
                    <Th>Timestamp</Th>
                    <Th className="w-56">Company</Th>
                    <Th className="">Action</Th>
                    <Th className="w-84">Assignee</Th>
                  </Tr>
                </THead>
                <tbody className={`overflow-y-auto notification-list `}>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center p-4">
                        Loading...
                      </td>
                    </tr>
                  ) : notificationList.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center p-4">
                        No data available
                      </td>
                    </tr>
                  ) : (
                    <>
                      {groupedNotifications.today.length > 0 && (
                        <>
                          <tr className="bg-gray-50/70 border-y border-gray-100">
                            <td
                              colSpan="5"
                              className="text-blue-700 font-bold px-6 py-2"
                            >
                              Today
                            </td>
                          </tr>
                          {groupedNotifications.today.map(renderTaskRow)}
                        </>
                      )}

                      {groupedNotifications.yesterday.length > 0 && (
                        <>
                          <tr className="bg-gray-50/70 border-y border-gray-100">
                            <td
                              colSpan="5"
                              className="text-blue-700 font-bold px-6 py-2"
                            >
                              Yesterday
                            </td>
                          </tr>
                          {groupedNotifications.yesterday.map(renderTaskRow)}
                        </>
                      )}

                      {groupedNotifications.thisWeek.length > 0 && (
                        <>
                          <tr className="bg-gray-50/70 border-y border-gray-100">
                            <td
                              colSpan="5"
                              className="text-blue-700 font-bold px-6 py-2"
                            >
                              This week
                            </td>
                          </tr>
                          {groupedNotifications.thisWeek.map(renderTaskRow)}
                        </>
                      )}

                      {groupedNotifications.thisMonth.length > 0 && (
                        <>
                          <tr className="bg-gray-50/70 border-y border-gray-100">
                            <td
                              colSpan="5"
                              className="text-blue-700 font-bold px-6 py-2"
                            >
                              This month
                            </td>
                          </tr>
                          {groupedNotifications.thisMonth.map(renderTaskRow)}
                        </>
                      )}


                      {/* --0--------------------------------------------- */}
                      {groupedNotifications.thisYear.length > 0 && (
                        <>
                          <tr className="bg-gray-50/70 border-y border-gray-100">
                            <td
                              colSpan="5"
                              className="text-blue-700 font-bold px-6 py-2"
                            >
                              This year
                            </td>
                          </tr>
                          {groupedNotifications.thisYear.map(renderTaskRow)}
                        </>
                      )}

                      {groupedNotifications.earlier.length > 0 && (
                        <>
                          <tr className="bg-gray-50/70 border-y border-gray-100">
                            <td
                              colSpan="5"
                              className="text-blue-700 font-bold px-6 py-2"
                            >
                              Earlier
                            </td>
                          </tr>
                          {groupedNotifications.earlier.map(renderTaskRow)}
                        </>
                      )}
                    </>
                  )}
                </tbody>
                {isFetching && (
                  <div className="flex justify-center py-4">
                    <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-blue-600"></div>
                  </div>
                )}
              </Table>
            </div>
          </div>
        </div>
        <CollapsiblePanel
          isCollapsed={isCollapsed}
          onToggle={() => setIsCollapsed(!isCollapsed)}
          title="Workers Overview"
        >
          <div className="bg-white p-5 border border-gray-200 rounded-xl dark-shadow">
            <div className="card-header flex justify-between border-b border-gray-200 pb-5">
              <span className="text-gray-900 text-base font-semibold flex items-center">
                <span className="mr-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M14.625 2.26953V6.40007C14.625 6.96012 14.625 7.24015 14.734 7.45406C14.8299 7.64222 14.9828 7.7952 15.171 7.89108C15.3849 8.00007 15.6649 8.00007 16.225 8.00007H20.3555M9.625 16L11.625 18L16.125 13.5M14.625 2H9.425C7.74484 2 6.90476 2 6.26303 2.32698C5.69854 2.6146 5.2396 3.07354 4.95198 3.63803C4.625 4.27976 4.625 5.11984 4.625 6.8V17.2C4.625 18.8802 4.625 19.7202 4.95198 20.362C5.2396 20.9265 5.69854 21.3854 6.26303 21.673C6.90476 22 7.74484 22 9.425 22H15.825C17.5052 22 18.3452 22 18.987 21.673C19.5515 21.3854 20.0104 20.9265 20.298 20.362C20.625 19.7202 20.625 18.8802 20.625 17.2V8L14.625 2Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                Worker Documents
              </span>
              {/* <BtnLight className="w-20 h-9">View All</BtnLight> */}
            </div>
            <div className="card-body pt-5">
              <div className="flex gap-3">
                <div className="h-20 flex flex-1 flex-col gap-2 items-center justify-center border border-gray-200 rounded-3xl">
                  <Tag className="bg-blue-100 text-blue-800">
                    Awaiting review
                  </Tag>
                  <span className="text-gray-600 text-sm font-semibold">
                    {workerCountData?.awaiting_review || 0}
                  </span>
                </div>
                <div className="h-20 flex flex-1 flex-col gap-2 items-center justify-center border border-gray-200 rounded-3xl">
                  <Tag className="bg-error-50 text-error-700">
                    Action required
                  </Tag>
                  <span className="text-gray-600 text-sm font-semibold">
                    {workerCountData?.action_required || 0}
                  </span>
                </div>
                <div className="h-20 flex flex-1 flex-col gap-2 items-center justify-center border border-gray-200 rounded-3xl">
                  <Tag className="bg-success-50 text-success-700">Approved</Tag>
                  <span className="text-gray-600 text-sm font-semibold">
                    {workerCountData?.approved || 0}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </CollapsiblePanel>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
